import { Alert, Dialog, Text } from "@merge-api/merge-javascript-shared";
import { ChevronRight } from "lucide-react";
import { BlueprintStep } from "../../../models/Blueprints";

interface Props {
  open: boolean;
  onClose: () => void;
  commonModelName: string;
  steps: BlueprintStep[];
  onSelectStep: (stepID: string) => void;
}

const CommonModelStepsModal = ({ open, onClose, commonModelName, steps, onSelectStep }: Props) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      footerButtonsHidden
      title={`Steps for ${commonModelName}`}
      variant="md"
    >
      <Alert color="blue" className="mb-3">
        NOTE: This list does not yet show which Code Block steps interact with any common models.
      </Alert>
      <div className="flex flex-col divide-y divide-gray-10">
        {steps.map((step) => (
          <button
            key={step.id}
            type="button"
            className="flex items-center justify-between gap-x-4 py-3 text-left hover:bg-gray-0"
            onClick={() => onSelectStep(step.id)}
          >
            <div className="flex flex-col">
              <Text variant="h6">{step.template.name}</Text>
              <Text variant="sm" className="text-gray-40">
                {step.id}
              </Text>
            </div>
            <ChevronRight size={16} className="text-gray-40 shrink-0" />
          </button>
        ))}
      </div>
    </Dialog>
  );
};

export default CommonModelStepsModal;
